import * as React from "react";

import "./error.scss";

import {
    ComponentLink,
    Link,
    makeChain,
    valueHelper as value,
}                                from "@Common/react/cst2";
import {Load2}                   from "@Common/react/load2";
import {Types}                   from "@Common/types";
import {isEmpty}                 from "@Common/utils/objects";

import {consumeContext} from "@Xpresso/loaders/consume-context";
import {Layout}         from "@Xpresso/routes/layout/layout";


export const Error = () => (
    makeChain<JSX.Element>()
    .then(...consumeContext("apis"))
    .then(...consumeContext("themeScheme"))
    .then("errorData", ({apis}, next:ComponentLink<typeof Load2<Types.Apis.Payloads.Next.Authenticate.Error.Response>>) => Load2({
        _key: "errorData",
        fetch: () => apis.next.authenticate.error(),
        next,
    }))
    .then(({
        errorData,
    }, next:Link<void>) => (
    <Layout className="error-1y7">
        {!isEmpty(errorData.value) ? (<>
            <div className="error-card" xd-qa-type="card" xd-qa-name="Error">
                <div className="header">
                    <div className="icon" xd-qa-type="icon" xd-qa-name="Alert">
                        <img alt="error" src={require("../common/alert.svg")}/>
                    </div>
                    <div className="code" xd-qa-type="label" xd-qa-name="Code">{`Error Code: ${errorData.value?.statusCode}`}</div>
                </div>
                <div className="body">
                    <div className="message" xd-qa-type="label" xd-qa-name="Message">
                        {errorData.value?.message}
                    </div>
                </div>
            </div>
            {errorData.value?.internalMessage && <div className="internal-message" xd-qa-type="label" xd-qa-name="Internal Message">
                Internal Message:<br/>
                <pre>{JSON.stringify(errorData.value?.internalMessage, null, 4)}</pre>
            </div>}
            </>) : errorData?.value && (<>
                Something went wrong! Please go back and try this action again.
            </>)}
    </Layout>
    ))
    .run()
);
